import styled from "styled-components";
import { IcardStyled, ISidebarCardStyled, ISidebarCardContainerStyled, IContentBarStyled } from "./interface";

export const SidebarCardContainer = styled.div<ISidebarCardContainerStyled>`
    min-height: 60vh;
    width: 100%;
    display: flex;
    margin: 4px 0;
    color: var(--default-color-font);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.02);
    background-color: var(--panel-body);

    @media(max-width: 600px){
        flex-direction: column;
    }

    ${(props) => props.styleInline && props.styleInline}
`;

export const SideBar = styled.div<ISidebarCardStyled>`
    padding: 2px 0.5rem 2px 0px;
    border-right: 1px solid var(--border-color);
    position: relative;
    min-width: ${(props) => props.listVisible ? "300px" : "30px"};
    max-width: 300px;

    .sidebar-arrow-container{
        position: absolute;
        left: 30px;
    }

    .sidebar-head{
        display: ${(props) => props.listVisible ? "block" : "none"};
        margin-bottom: 15px;

        .sidebar-nav{
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    .sidebar-body{
        min-height: 50px;
    }

    .sidebar-arrow{
        position: absolute;
        right: 1px;
        cursor: pointer;
    }

    @media(max-width: 600px){
        min-width: 180px;
    }
    
    @media(max-width: 600px){
        width: 100%;
        max-width: 100%;
        border-right: none;
        border-bottom: 1px solid var(--border-color)
    }
`;

export const ContentBar = styled.div<IContentBarStyled>`
    width: 100%;
    max-width: ${(props) => props.listVisible ? "calc(100% - 300px)" : "calc(100% - 30px)"};
    padding: 0 0 0 0.5rem;

    @media(max-width: 600px){
        padding: 0.5rem 0;
        max-width: 100%;
    }
`;


export const SidebarContent= styled.div<{ showFilters: boolean }>`
	width: 100%;
    display: flex;
    ${(props) => props.showFilters ? "display: flex;" : "display: none;"}
`;



export const Card =styled.div<IcardStyled>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    width: 100%;
    min-height: 70px;

    margin: 8px 0;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: ${(props) => props.selected ? "var(--main-color)" : "var(--card-background)"};
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    &:hover{
        background: ${(props) => props.selected ? "var(--purple-darker)" : "var(--border-color)"};
    }

    .card-body{
        font-weight: bold;
        color: ${(props) => props.selected ? "white" : "unset"};
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .card-footer{
        font-size: 0.7rem;
        color: ${(props) => props.selected ? "white" : "unset"};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .icon-options{
        position: absolute;
        top: -4px;
        right: -8px;
    }

    .icon-favorite{
        position: absolute;
        top: 3px;
        left: 5px;
    }

    ${(props) => props.active !== undefined && `
        ${props.active === true ? "border-left: 4px solid var(--green);" : ""}
        ${props.active === false ? "border-left: 4px solid var(--red);" : ""}
    `}
`;

export const Content =styled.div<IcardStyled>`
    display: ${(props) => props.selected ? "block" : "none"};
`;

export default SidebarCardContainer;
